module.exports = __webpack_public_path__ + "media/img/resources/flyer-thumbnail-076c96ecaa8c9ad6250052ed06d1e7ee.jpg";